export const designations = [
    {
        value: 'INTERN',
        label: 'Intern',
    },
    {
        value: 'JUNIOR_SOFTWARE_DEVELOPER',
        label: 'Junior Software Developer',
    },
    {
        value: 'SENIOR_SOFTWARE_DEVELOPER',
        label: 'Senior Software Developer',
    },
    {
        value: 'LEAD_DEVELOPER',
        label: 'Lead Developer',
    },
    {
        value: 'ENGINEERING_MANAGER',
        label: 'Engineer Manager',
    },
    {
        value: 'SDET',
        label: 'SDET',
    },
];
